
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import { Link, Box, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
// sections
import { ForgotForm } from '../sections/auth/forgot';
import { LoginForm } from '../sections/auth/login';
import { SignupForm } from '../sections/auth/signup';
import { Api } from '../webservices';
// ----------------------------------------------------------------------


const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  maxWidth: 550,
  width: '100%',
  minHeight: '100vh',
  // paddingTop:50,
  // paddingLeft: 90,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  // boxShadow: theme.customShadows.card,
  // backgroundColor: theme.palette.background.default,
  // backgroundImage: `url('/assets/logo.svg')`,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 550,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate()
  const [forgot, setForgot] = useState(false)
  const func = (e) => {
    setForgot(true)
  }

  const func1 = (e) => {
    setForgot(false)
  }

const handleApply = () => {
  Api('company/guest_user', 'GET')
    .then((response) => {
     
      if (response?.data?.token) {
        
         localStorage.setItem("token", response.data.token);

        navigate("/apply-job");

      } else {
        console.log("API Error:", response?.data?.message);
      }
    })
    .catch((error) => {
      console.log("Error:", error);
    });
};


  // const func2 = (e) => {
  //   setForgot(false)
  // }

  // const [currentForm, setCurrentForm] = useState('login');

  // const showLogin = () => {
  //   setCurrentForm('login');
  // };

  // const showForgot = () => {
  //   setCurrentForm('forgot');
  // };

  // const showSignup = () => {
  //   setCurrentForm('signup');
  // };

  const linkStyle = {
    fontSize:"15px",
    color: 'text.secondary',
    fontWeight: "bold",
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    }
  };

  return (
    <>
      <Helmet>
        <title> Login | Foxearch </title>
      </Helmet>

      <StyledRoot backgroundColor="#F5F5F5">
        {/* <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        /> */}
        <Box sx={{
          position: 'fixed',
          top: { xs: 10, sm: 24, md: 40 },
          left: { xs: 10, sm: 24, md: 40 },
        }}>
          <Link to="/" sx={{ display: 'contents' }}>
            <img alt="." src='/assets/logoBlue.svg' height={"80%"} width={"80%"} />
          </Link>
        </Box>
        {mdUp && (
          <StyledSection>
            <Stack sx={{
              justifyContent: 'center',
              height: '60%',
              backgroundRepeat: 'no-repeat',
              // backgroundImage: `url('/assets/greylogo.png')`,
              backgroundSize: 'auto',
              backgroundPosition: 'center',
            }}>
              {/* <Typography color={'text.secondary'} sx={{ fontStyle: 'italic', fontSize: '30px'}}>
              Foxearch
            </Typography> */}
              <Stack sx={{ flexDirection: 'row', justifyContent: 'center' }}>
                <Typography variant="h5" sx={{ fontWeight: '600', color: 'text.secondary' }} color="#2E3C49">
                  ATS&nbsp;
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: '600', color: 'black' }} color="text.secondary">
                  |&nbsp;
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: '600', color: 'text.secondary' }} color="#2E3C49">
                  VMS&nbsp;
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: '600', color: 'black' }} color="text.secondary">
                  |&nbsp;
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: '600', color: 'text.secondary' }} color="#2E3C49">
                  {/* SOS */}
                  CRM
                </Typography>
              </Stack>
              <Typography color="#1D2630" sx={{ textAlign: 'center' }} variant="h6">
                An Ultimate Destination for All Your Hiring Endeavours
              </Typography>
                     <Box sx={{ display: "flex", justifyContent: "center" }}>

                      <Button
    onClick={handleApply}
    
     variant="contained"
                    size="small"
                    color="custom"
    sx={{
      textAlign: "center",
      // backgroundColor: "#3C6BA5",
      // textTransform: "none",
    //  borderRadius: "15px",
      padding: "4px 29px",
      fontWeight: 600,
      fontSize: "20px",
      width: "fit-content",
      mt: 1,
      // "&:hover": {
      //   backgroundColor: "#6c8fbe",
      // },
    }}
  >
    Apply for Job
                    </Button>


</Box>
                 
  
                 
            </Stack>
          </StyledSection>
        )}
        <Stack >
          <StyledContent>
            { }

            {/* <Typography variant="body2" sx={{ mb: 5 }}>
              Don’t have an account? {''}
              <Link variant="subtitle2">Click here</Link>
            </Typography>

            <Stack direction="row" spacing={2}>
              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:google-fill" color="#DF3E30" width={22} height={22} />
              </Button>

              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:facebook-fill" color="#1877F2" width={22} height={22} />
              </Button>

              <Button fullWidth size="large" color="inherit" variant="outlined">
                <Iconify icon="eva:twitter-fill" color="#1C9CEA" width={22} height={22} />
              </Button>
            </Stack>

            <Divider sx={{ my: 3 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                OR
              </Typography> */}
            {/* </Divider> */}
            {forgot === false ? (
              <LoginForm func={(e) => func(e)} />
            ) : (
              <ForgotForm func1={(e) => func1(e)} />
            )}

            {/* <SignupForm func2={(e) => func2(e)}/> */}
            {/* <Typography color={'#1D2630'} variant="caption" margin={'28px 0 0 70px'}>
              Contact Sales : (386) 465 2764
            </Typography> */}
          </StyledContent>
        </Stack>
      </StyledRoot>

      {/* Footer */}

      <Stack
        flexDirection={'row'}
        alignItems={'flex-end'}
        justifyContent={'space-between'}
        sx={{
          mt: -5,
          flexWrap: 'nowrap', 
          alignItems: 'center',
          paddingLeft: "35px",
          paddingRight: "35px"
        }}
      >

        <Stack
          // color="#1D2630"
          flexDirection={'row'}
          sx={{
            gap: 5,
            flexWrap: "wrap",
            // mt: -5, 
            // padding: 2 

          }}
        >
          <Typography variant="body2" sx={linkStyle} onClick={() =>{ navigate('/home'); window.location.reload()}}>
            Home
          </Typography>
          <Typography variant="body2" sx={linkStyle} onClick={() => navigate('/productDemo')}>
            Product Demo
          </Typography>
          <Typography variant="body2" sx={linkStyle} onClick={() => {navigate('/aboutUs'); window.location.reload()}}>
            About Us
          </Typography>
          <Typography variant="body2" sx={linkStyle} onClick={() => navigate('/careers')}>
            Careers
          </Typography>
          <Typography variant="body2" sx={linkStyle} onClick={() => navigate('/blogs')}>
            Blogs
          </Typography>
          <Typography variant="body2" sx={linkStyle} onClick={() => navigate('/contactUs')}>
            Contact Us
          </Typography>
        </Stack>
        <Stack flexDirection={'row'} gap={3}>

          <Typography variant="body2" sx={{ fontWeight: "bold" }} color={'text.secondary'}>
            Copyright © {new Date().getFullYear()} Foxearch Inc.
          </Typography>
        </Stack>
      </Stack>
    </>
  );
}
